import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BillingComponent } from './billing/billing.component';
import { ClinicDetailsComponent } from './clinic-details/clinic-details.component';
import { ClinicSubmittedComponent } from './clinic-submitted/clinic-submitted.component';
import { ContactComponent } from './contact/contact.component';
import { OrganisationComponent } from './organisation/organisation.component';
import { ReviewDetailsComponent } from './review-details/review-details.component';
import {AuthGuard} from './services/authguard.service'
import { ServicesComponent } from './services/services.component';

const routes: Routes = 
[

  {path:"", component:ContactComponent},
  { path: '', redirectTo: '/contact', pathMatch: 'full' },
  { path: 'contact', component: ContactComponent, canActivate:[AuthGuard] },
  { path: 'organisation', component: OrganisationComponent},
  { path: 'services', component: ServicesComponent},
  { path: 'clinic-details', component: ClinicDetailsComponent},
  { path: 'billing', component: BillingComponent},
  { path: 'review-details', component: ReviewDetailsComponent},
  { path: 'clinic-submitted', component: ClinicSubmittedComponent},
  { path: '**', redirectTo: '/contact', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash:false, anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
